export const REPORTING_SELECT_ID = 'REPORTING_SELECT_ID';

/* CREATE FEATURE */
export const CF_NAME_ID = 'CF_NAME_ID';
export const CF_TYPE_ID = 'CF_TYPE_ID';
export const CF_DESC_ID = 'CF_DESC_ID';
export const CF_CREATE_BTN_ID = 'CF_CREATE_BTN_ID';
